import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Box, Button, Text } from "ui-components";
import PageHeader from "components/PageHeader";
import { gotoUrl } from "utils/helpers";

const AuthorizationStatus = props => {
  const { authorizeDelivery, deliveryStatus, label, url } = props;
  const authorizePath = deliveryStatus && `order_authorize_${deliveryStatus}`;
  const pageHeaderKey = authorizePath;
  const statusMessageKey = authorizePath && `${authorizePath}_message`;

  return (
    <Box
      textAlign="left"
      variant="main"
      padding="2rem"
      data-testid="schedule-delivery-success"
    >
      {pageHeaderKey && <PageHeader title={pageHeaderKey} />}
      {statusMessageKey && (
        <Text>
          <FormattedMessage
            html
            id={statusMessageKey}
            values={authorizeDelivery}
          />
        </Text>
      )}
      <Box textAlign="center" paddingTop="2rem">
        <Button onClick={() => gotoUrl(url, false, {}, true)}>{label}</Button>
      </Box>
    </Box>
  );
};

AuthorizationStatus.defaultProps = {
  label: "Go to Manage Order",
  url: "/manage/order"
};

export default AuthorizationStatus;
